import {
  BulkStudentResultPayload,
  StudentResultPayload,
} from "../../Constants/Interfaces/payloadInterface/ResultsPayload.interface";
import { getValue } from "../../utils/object.utils";

export const result = {};

export const parseStudentMetadata = (raw: any) => {
  if (!raw) return {};
  if (typeof raw === "string") {
    try {
      const parsed = JSON.parse(raw);
      return parsed && typeof parsed === "object" ? parsed : {};
    } catch {
      return {};
    }
  }
  if (typeof raw === "object") return raw;
  return {};
};

export const buildStudentResultPayload = ({
  resultId,
  student,
}: {
  resultId: number;
  student: any;
}): StudentResultPayload | null => {
  const studentId = getValue(student, "student_id");
  if (!studentId) return null;

  const resultEntries = getValue(student, "result_entries", []);
  const metadata = parseStudentMetadata(getValue(student, "metadata", {}));

  return {
    student_id: studentId,
    result_id: resultId,
    result_entries: resultEntries.map((entry: any) => ({
      subject_id: entry?.subject_id,
      marks: entry?.marks,
      grade: entry?.grade,
    })),
    remarks: getValue(student, "remarks", ""),
    height: getValue(metadata, "height"),
    weight: getValue(metadata, "weight"),
    attendance: getValue(metadata, "attendance"),
  };
};

/**
 * Builds the bulk-save payload from the students currently loaded in the
 * spreadsheet. `result_id` is sent once (not repeated per student). Each
 * student item keeps the same fields the single-student save already sent.
 * Students without a `student_id` are skipped so we never post a broken row.
 */
export const buildBulkStudentResultPayload = ({
  resultId,
  students,
}: {
  resultId: number;
  students: any[];
}): BulkStudentResultPayload => {
  return {
    result_id: resultId,
    students: students.reduce(
      (acc: BulkStudentResultPayload["students"], student) => {
        const payload = buildStudentResultPayload({ resultId, student });
        if (!payload) return acc;

        const { result_id: _resultId, ...studentPayload } = payload;
        acc.push(studentPayload);
        return acc;
      },
      [],
    ),
  };
};
// =IF(AND(C10>=90,C10<=100),"A+",IF(AND(C10>=80,C10<=89.9),"A",IF(AND(C10>=70,C10<=79.9),"B+",IF(AND(C10>=60,C10<=69.9),"B",IF(AND(C10>=50,C10<=59.9),"C+",IF(AND(C10>=40,C10<=49.9),"C","D"))))))
// =IF(AND(M10>=45,M10<=50),"A+",IF(AND(M10>=40,M10<=44.9),"A",IF(AND(M10>=35,M10<=39.9),"B+",IF(AND(M10>=30,M10<=34.9),"B",IF(AND(M10>=25,M10<=29.9),"C+",IF(AND(M10>=20,M10<=24.9),"C","D"))))))
export const computeGradeFromMarks = ({
  marks,
  fullMarks,
}: {
  marks: number;
  fullMarks: number;
}): string => {
  const multiplier = 100 / fullMarks;

  const adjustedMarks = marks * multiplier;

  if (adjustedMarks >= 90 && adjustedMarks <= 100) return "A+";
  else if (adjustedMarks >= 80 && adjustedMarks <= 89.9) return "A";
  else if (adjustedMarks >= 70 && adjustedMarks <= 79.9) return "B+";
  else if (adjustedMarks >= 60 && adjustedMarks <= 69.9) return "B";
  else if (adjustedMarks >= 50 && adjustedMarks <= 59.9) return "C+";
  else if (adjustedMarks >= 40 && adjustedMarks <= 49.9) return "C";
  else return "D";
};
